<template>
  <div>
<van-pull-refresh v-model="refreshing" @refresh="onRefresh">    
    <van-list
      v-model="upLoading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
       v-show="articles.length > 0"
    >
    <div class="van-clearfix">
    <div
     
            style="margin-top: 5px; margin-bottom: 5px"
            v-for="(item, index) in articles"
            :key="item.userId"
          >
            <van-row>
           
 <van-col span="4"> <div style="    margin-left: 10px;
    text-align: center;
    font-size: 15px;  height: 41px;margin-top: 8px; color: #6c6c6c;">{{index+1}}</div> </van-col>
              <van-col span="3">
                <van-image
                 
                  round
                  width="41px"
                  height="41px"
                  fit="fill"
                  :src="item.headImgurl"
                />
               
               
              </van-col>
              <van-col span="11">
                <div
                  style="
                   
                    color: #069;
                    font-size: 16px;
                    font-weight: bold;
                    width: 100%;
                    height: 41px;
                  "
                >
                  <div style="margin-top: 8px">
                   {{ item.trueName }}  ( {{ item.departName }} )

                  <userIcon :iconstring="item.icon" ></userIcon>
                  </div>
                </div>
              </van-col>
                 <van-col span="6"> <div style="  
    height: 41px;margin-top: 8px;"> {{ item.createTime }}</div> </van-col>
            </van-row>
          </div>
    </div>
    </van-list>


 <van-empty v-show="articles.length == 0" description="暂无数据" image="/image/empty-image-default.png" />


    </van-pull-refresh>
  </div>
</template>

<script>
import { getBrowsingLogList } from "@/api/browsingLog";


import UserIcon from "@/views/components/userIcon";

//const key = "zn-history";
export default {
  name: "browsinglog",
  props: {
    filterData: Object,
    SorterType: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      scroll: 0,
      refreshing: false,
    
      title: "",
     
      upLoading: false,
      finished: false,
      articles: [],
      page: {
        SorterType:2,
        current: 1,
        pageSize: 20,
        sorterType: 0,
        filterData: {},
      },
    };
  },
  components: {UserIcon,},
  activated() {
    //  window.scrollTo(0, this.scroll);
    //  alert( this.$refs.wrapper.scrollTop);
    // try {
    //   this.$refs.wrapper.scrollTop = this.scroll;
    // } catch (error) {
    //   console.log(error);
    // }
  },
  created() {
    this.initData();
    this.onSearch();
  },
  mounted() {},

  methods: {
    onRefresh() {
      this.onSearch();
      this.refreshing = false;
    },
    async initData() {
      this.page.filterData = this.filterData; 
      this.page.SorterType=this.SorterType;   
    },
   
    onSearch() {
      this.finished = false;
      this.articles = [];
      this.page.current = 1;
      this.page.pageSize = 10;
      this.onLoad();
    },

    async onLoad() {
      console.log("ranklist load....")
      this.upLoading = true;
      // if (this.articles.length > 0 && this.page.current == 1) {
      //    this.upLoading = false;
      //   return;
      // }

      let aresult = await getBrowsingLogList({ ...this.page }); //({ ...this.page })
      this.articles.push(...aresult.data.data);
      this.upLoading = false;

      if (this.page.current * this.page.pageSize < aresult.data.total) {
        this.page.current++;
      } else {
        this.finished = true;
      }
    },
    
  },
};
</script>

<style lang="less" scoped>

</style>
